import { environment } from '../../../environments/environment';

export const API_CONFIG = {
  origin: environment.api.origin,
  basePath: environment.api.basePath,
} as const;

export function buildApiUrl(path: string) {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${API_CONFIG.origin}${API_CONFIG.basePath}${normalizedPath}`;
}
